import { useQuery } from "@tanstack/react-query";
import { akitaFetch } from "data/akita-fetch";
import { GetAdminDashboardsOrganizationsResponse } from "types/akita_api_types";

const getInternalOrgs = () =>
  akitaFetch<GetAdminDashboardsOrganizationsResponse>("/admin/dashboards/organizations");

export const useInternalOrgs = () => useQuery(["internal-orgs"], getInternalOrgs);
